import { IWall } from '../models/wall';
import { User } from '../models/user';
import { IPost } from '../models/post';
import { IComment } from '../models/comment';
import { wallReducer } from './wall';
import { postReducer } from './post';
import { commentReducer } from './comment';
import {userReducer} from './user';
import {combineReducers} from 'redux';
import { postMetadataReducer } from './post';
import {contactFormReducer} from './user';

interface Store {
    wall:IWall | null;
    posts: [IPost] | null;
    comments: [IComment] | null;
    user: User;
    postsMetadata:any | null;
    contactForm:any;
}

export const rootReducer = combineReducers<Store>({wall: wallReducer, posts: postReducer, comments: commentReducer, user: userReducer, postsMetadata: postMetadataReducer, contactForm: contactFormReducer});